// extracted by mini-css-extract-plugin
export default {"breakdown-list":"BreakdownList_breakdown-list__yuCZ-"};